module.exports = __webpack_public_path__ + "media/images/avatar/02-542c847c3be7078b45b90d8b232909fa.jpg";